export const DEFAULT_SSR_IMAGE_URL =
  'https://cdn.dotpe.in/kiranaStatic/image/default-ssr-icon-22092020.png';
